import { Header } from "./landing/Header";
import { Hero } from "./landing/Hero";
import { WhyItMatters } from "./landing/WhyItMatters";
import { AboutFirm } from "./landing/AboutFirm";
import { TaxBanner } from "./landing/TaxBanner";
import { Process } from "./landing/Process";
import { LegalTax } from "./landing/LegalTax";
import { Incentives } from "./landing/Incentives";
import { LandLeasing } from "./landing/LandLeasing";
import { SectorOpportunities } from "./landing/SectorOpportunities";
import { WorldConnect } from "./landing/WorldConnect";
import { UpdatesFeed } from "./landing/UpdatesFeed";
import { EditorialMarquee } from "./landing/EditorialMarquee";
import { LeadForm } from "./landing/LeadForm";
import { Testimonials } from "./landing/Testimonials";
import { Faq } from "./landing/Faq";
import { Locations } from "./landing/Locations";
import { Footer } from "./landing/Footer";
import { FloatingWhatsApp } from "./landing/FloatingWhatsApp";

export default function LandingPage() {
  return (
    <div className="grain no-x-overflow relative min-h-screen bg-[var(--page)] text-[var(--ink)]">
      <Header />
      <main>
        <Hero />
        <WhyItMatters />
        <AboutFirm />
        <Process />
        <LegalTax />
        <TaxBanner />
        <Incentives />
        <LandLeasing />
        <SectorOpportunities />
        <WorldConnect />
        <UpdatesFeed />
        <EditorialMarquee />
        <Testimonials />
        <LeadForm />
        <Faq />
        <Locations />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
